import React from 'react';

SearchIcon.defaultProps = {
    size: 16,
    viewBox: '0 0 1024 1024',
    fill: '',
    transform: '',
    onClick: () => null,
    color: 'black',
};

export default function SearchIcon(props: any) {
    const styles = {
        svg: {
            display: 'inline-block',
            verticalAlign: 'middle',
        },
    };

    return (
        <svg
            id={props.id}
            className={props.className}
            style={styles.svg}
            // width={`${props.size}px`}
            height={`${props.size}px`}
            viewBox={props.viewbox}
            fill={props.color}
            onClick={(event?: any) =>
                props.onClick(event) && props.onClick(event)
            }
        >
            <path fill={props.fill} d={props.d} transform={props.transform} />
        </svg>
    );
}
